import React, { Component } from 'react'
import Link from 'components/Link';
import SelectLanguage from './SelectLanguage';
import './_header.scss';
import { FormattedMessage } from 'react-intl';
import Logo from '../Logo';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            navExpanded: false
        }

        this.hamburgerClickHandler = this.hamburgerClickHandler.bind(this);
    }

    hamburgerClickHandler(e) {
        this.setState(prevState => ({
            navExpanded: !prevState.navExpanded
        }));
    }

    render() {
        let hamburgerStyles = [
            "hamburger",
            this.state.navExpanded ? "change" : null
        ].join(' ');

        let mobileNavStyles = [
            "mobileNav",
            this.state.navExpanded ? "expanded" : null
        ].join(' ');

        return (

            <nav className="navBar">
                <div className="wrapper">
                    <div className="navBarLogo">
                        <Link to="/">
                            <Logo size={50} />
                        </Link>
                    </div>

                    <div className="desktopNav">
                        <ul className="navbar-left">
                            {
                                this.props.menu && this.props.menu.map((link, i) => (
                                    <li key={`l${i}`}>
                                        <Link to={link.slug} activeClassName="activeLink">
                                            <FormattedMessage id={link.label} />
                                        </Link>
                                    </li>
                                ))
                            }
                        </ul>

                        <ul className="navbar-right">
                            <li>
                                <Link href="https://studio.scichess.com">
                                    <FormattedMessage id="signIn" />
                                </Link>
                            </li>

                            <li>
                                <SelectLanguage langs={this.props.langs} intl={this.props.intl} size="40" />
                            </li>
                        </ul>

                    </div>

                    <div className={hamburgerStyles} onClick={this.hamburgerClickHandler}>
                        <div className="bar1"></div>
                        <div className="bar2"></div>
                        <div className="bar3"></div>
                    </div>

                    <div className={mobileNavStyles}>
                        <ul>
                            {
                                this.props.menu && this.props.menu.map((link, i) => (
                                    <li key={`m${i}`}>
                                        <Link to={link.slug} activeClassName="activeLink">
                                            <FormattedMessage id={link.label} />
                                        </Link>
                                    </li>
                                ))
                            }
                            <hr />

                            <li>
                                <Link href="https://studio.scichess.com">
                                    <FormattedMessage id="signIn" />
                                </Link>
                            </li>

                            <li>
                                <SelectLanguage langs={this.props.langs} intl={this.props.intl} size="40" />
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
}

export default Header;




// WEBPACK FOOTER //
// ./src/components/Header/index.js